/** IA visual: análises das fotos da conversa (o tempo real atualiza a chave). */
import type { EstadoVisao, IdentificacaoProduto } from "@ydchat/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { toast } from "sonner";
import { api, ErroApi } from "./api";

const chave = (conversaId: string) => ["conversa", conversaId, "visao"];

export function useVisao(conversaId: string) {
  const q = useQuery({
    queryKey: chave(conversaId),
    queryFn: () => api.get<EstadoVisao>(`/conversas/${conversaId}/copiloto/visao`),
    staleTime: 30_000,
  });
  return useMemo(
    () => ({
      disponivel: q.data?.disponivel ?? false,
      porMensagem: new Map<string, IdentificacaoProduto>(
        (q.data?.identificacoes ?? []).map((i) => [i.mensagemId, i]),
      ),
      analisando: new Set(q.data?.analisando ?? []),
    }),
    [q.data],
  );
}

export function useAnalisarFoto(conversaId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (mensagemId: string) =>
      api.post(`/conversas/${conversaId}/copiloto/visao`, { mensagemId }),
    onMutate: (mensagemId) =>
      qc.setQueryData<EstadoVisao>(chave(conversaId), (e) =>
        e ? { ...e, analisando: [...e.analisando, mensagemId] } : e,
      ),
    onError: (e) => {
      toast.error(e instanceof ErroApi ? e.message : "Não foi possível analisar a foto.");
      void qc.invalidateQueries({ queryKey: chave(conversaId) });
    },
  });
}
